import { Component, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-users-create-employee-login",
  templateUrl: "./admin-users-create-employee-login.component.html",
  styleUrls: ["./admin-users-create-employee-login.component.css"],
})
export class AdminUsersCreateEmployeeLoginComponent implements OnInit {
  CreateEmployeeLogin: FormGroup;
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  token: any;

  constructor(
    private matdialogref: MatDialogRef<AdminUsersCreateEmployeeLoginComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private services: AdminService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.CreateEmployeeLogin = this.formBuilder.group({
      employee_id: [""],
      username: ["", Validators.required],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: [
        "",
        Validators.compose([
          // Validators.required,
          Validators.pattern(this.emailregex),
        ]),
      ],
      password: [""],
      designation: [""],
      employee_role: [""],
      confirm_password: [""],
    });
  }

  close() {
    this.matdialogref.close();
  }
  createEmployee() {
    let employeeid = this.CreateEmployeeLogin.value.employee_id;
    if (!employeeid) {
      this.snackBar.open("Please enter employee id", "Fail", {
        duration: 5000,
      });
      return;
    }
    let designation = this.CreateEmployeeLogin.value.designation;
    if (!designation) {
      this.snackBar.open("Please enter designation", "Fail", {
        duration: 5000,
      });
      return;
    }
    let name = this.CreateEmployeeLogin.value.username;
    if (!name) {
      this.snackBar.open("Please enter username", "Fail", {
        duration: 5000,
      });
      return;
    }
    let employeerole = this.CreateEmployeeLogin.value.employee_role;
    if (!employeerole) {
      this.snackBar.open("Please enter employee role", "Fail", {
        duration: 5000,
      });
      return;
    }
    let mobile = this.CreateEmployeeLogin.value.mobile;
    if (!mobile) {
      this.snackBar.open("Please enter mobile", "Fail", {
        duration: 5000,
      });
      return;
    }
    let email = this.CreateEmployeeLogin.value.email;
    if (!email) {
      this.snackBar.open("Please enter email", "Fail", {
        duration: 5000,
      });
      return;
    }
    let password = this.CreateEmployeeLogin.value.password;
    if (!password) {
      this.snackBar.open("Please enter password", "Fail", {
        duration: 5000,
      });
      return;
    }
    let confirmpassword = this.CreateEmployeeLogin.value.confirm_password;
    if (!confirmpassword) {
      this.snackBar.open("Please enter confirm password", "Fail", {
        duration: 5000,
      });
      return;
    }
    const employeeObj = {
      employee_id: this.CreateEmployeeLogin.value.employee_id,
      username: this.CreateEmployeeLogin.value.username,
      mobile: this.CreateEmployeeLogin.value.mobile,
      email: this.CreateEmployeeLogin.value.email,
      password: this.CreateEmployeeLogin.value.password,
      designation: this.CreateEmployeeLogin.value.designation,
      employee_role: this.CreateEmployeeLogin.value.employee_role,
    };
    this.services.createEmployee(employeeObj, this.token).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.matdialogref.close();
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }
}
